import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { getClassNames, retrieveFromLocalStorage } from '../../../../utils/util';

import HelpCenterMenu from '../help-center-menu/HelpCenterMenu';
import Message from '../../../common/message/Message';

import { ReactComponent as SendIcon } from '../../../../resources/icons/send.svg';

import './contact-us.scss';

const ContactUs = ({ chat, sendMessage }) => {
  const [message, setMessage] = useState('');
  const [sendingMessage, setSendingMessage] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);

  const endOfMessagesRef = useRef(null);
  const inputRef = useRef(null);
  const messageContainerRef = useRef(null);

  useEffect(() => {
    if (!endOfMessagesRef.current) return;

    if (initialLoad) {
      endOfMessagesRef.current.scrollIntoView();
      setInitialLoad(false);
    } else {
      endOfMessagesRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [chat?.messages?.length, initialLoad]);

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
    inputRef.current.style.height = '40px';
    inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;

    if (inputRef.current.scrollHeight <= 40) {
      messageContainerRef.current.style.height = 'calc(100vh - 320px)';
    } else if (inputRef.current.scrollHeight <= 60) {
      messageContainerRef.current.style.height = 'calc(100vh - 340px)';
      messageContainerRef.current.scrollBy(0, 40);
    } else if (inputRef.current.scrollHeight <= 82) {
      messageContainerRef.current.style.height = 'calc(100vh - 360px)';
      messageContainerRef.current.scrollBy(0, 40);
    }
  };

  const handleSendMessageClick = () => {
    if (!message || sendingMessage) return;

    setSendingMessage(true);

    sendMessage(message, () => {
      setMessage('');
      setSendingMessage(false);
      inputRef.current.style.height = '40px';
      messageContainerRef.current.style.height = 'calc(100vh - 320px)';
    });
  };

  const renderMessages = () => {
    if (!chat.messages || chat.messages?.length === 0) {
      return (
        <div className="contact-us__chat__no-messages">
          <p>No Messages</p>
        </div>
      );
    }

    const reversedMessages = [...chat.messages].reverse();
    return reversedMessages.map((message, index) => {
      const right = message.personExternalReference === retrieveFromLocalStorage('personExternalReference');

      return <Message key={index} message={message} right={right} />;
    });
  };

  return (
    <section className="contact-us">
      <HelpCenterMenu />

      <section className="contact-us__content">
        <section className="contact-us__header">
          <p className="contact-us__title">Contact Us</p>
        </section>

        <section className="contact-us__chat">
          <ul className="contact-us__chat__messages" ref={messageContainerRef}>
            {renderMessages()}
            <span ref={endOfMessagesRef} />
          </ul>

          <div className="contact-us__chat__input">
            <textarea value={message} onChange={handleMessageChange} ref={inputRef} data-testid="chat-input" />
            <SendIcon
              className={getClassNames('contact-us__chat__input__button', { sending: sendingMessage })}
              onClick={handleSendMessageClick}
              data-testid="send-icon"
            />
          </div>
        </section>
      </section>
    </section>
  );
};

ContactUs.propTypes = {
  chat: PropTypes.shape({}),
  sendMessage: PropTypes.func.isRequired,
};

ContactUs.defaultProps = {
  chat: undefined,
};

export default ContactUs;
